import { Flex, Text, Image } from '@chakra-ui/react';
import emptyReadersSrc from '../../../assets/vectors/empty-readers.svg';

const PreviewUnavailable = () => {
  return (
    <Flex
      pos="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="#E0E0E0"
      minW="330px"
      minH="350px"
      maxW="full"
      maxH="full"
      boxShadow="0px 6px 13px rgb(0 0 0 / 15%)"
      borderRadius="10px"
      color="#29323A"
      alignItems="center"
      justifyContent="center"
      opacity="1"
      zIndex="2"
    >
      <Flex alignItems="center" flexDirection="column" gap={2}>
        <Image src={emptyReadersSrc} alt="Empty readers" />
        <Text
          fontSize="14px"
          textStyle="bodyRoman"
          textAlign="center"
          cursor="default"
        >
          Preview unavailable
          <br />
          Transit type is currently API-only
        </Text>
      </Flex>
    </Flex>
  );
};

export default PreviewUnavailable;
